import { useParams } from "react-router-dom";
import FormularioOrientacaoCompleta from "../../components/Demanda/AbaOrientacoes/OrientacoesCompletas/Formulario";

export default function FormularioOrientacaoCompletaPage() {
    const params = useParams<{ id: string }>();
    const id = Number(params.id);

    return <FormularioOrientacaoCompleta idDemanda={id} />;
}

